<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" viewBox="0 0 54 60">
    <polygon :fill="fill" points="2,59 52,1 2,1 "/>
  </svg>
</template>

<script>
export default {
  name: "TriangleLeft",
  props: {
    title: {
      default: 'Triangle',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 20,
    },
  },
}
</script>
